import React, { useRef, useContext, useState, useEffect } from "react";
import ReactCrop from "react-image-crop";
import MyContext from "../../../context/MyContext";
import swal from "sweetalert";
import TickerContext from "../../../context/ticker";
import styled, { keyframes } from "styled-components";
import Draggable from "react-draggable";
import LockBar from "../lockBar";
import ProjectContext from "../../../context/ProjectContext";
import { TryRounded } from "@mui/icons-material";

const TrackerImages = ({
  setAtoZ,
  value,
  StackStore,
  TickerPosition,
  resizeRef,
  resizeRef2,
  zInd,
  index,
  TickerStart,
  setMultiDrag,
  MultiDrag,
  Call_ScreenShot,
  setCall_ScreenShot,
}) => {
  const {
    clone,
    CanvasDisplay,
    setLayersData,
    LayersData,
    ChangeCount,
    setChangeCount,
    EditorZoom,
    calculateTimeByWidth,
    onePxEquivalent,
    Dragging,
    seteditableObject,
    setDragging,
    isCrop,setIsCrop,
    IsPressedShiftKey
  } = useContext(MyContext);

  const { Click_TickerPosition } = useContext(TickerContext);

  const { slides, setslides } = useContext(ProjectContext);

  const [completedCrop, setCompletedCrop] = useState(null);

  const [cropedUrl, setCropedUrl] = useState("");

  const [AnimationStyle, setAnimationStyle] = useState("");

  const [StoreData, setStoreData] = useState(null);

  const dragref = useRef(null);

  const imageRef = useRef(null);

  const Unlock = async (obj) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === obj) {
        array[i].lock = false;
        array[i].layerlock = false;
        array[i].showDiv = true;
        
      }
    }
    setLayersData(array);
  };

  const onImageLoaded = (e) => {
    // if (aspect) {
    //     const { width, height } = e.currentTarget
    //     setCrop(centerAspectCrop(width, height, aspect))
    //   }
    // debugger;
    setCompletedCrop(e.target);
    // setCrop({
    //   unit: "px",
    //   width: value.width,
    //   height: value.height,
    // });
    //= image;
  };

  const onCropComplete = (c) => {
    value.Editable = false;
    makeClientCrop(c);
  };

  const onCropChange = (c, percentCrop) => {
   
    setCrop(c);
    value.Editable = false;
  };

  const cropImg = async (key) => {
  
    if (completedCrop && crop.width && crop.height) {
      await StackStore();
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          array[i].ImageSrc = cropedUrl;
          array[i].crop = "false";
          array[i].Editable = false;
          array[i].showDiv = false;
          array[i].width = (crop.width * EditorZoom) / 100;
          array[i].height = (crop.height * EditorZoom) / 100;
          break;
        }
      }
      setLayersData(array);
      setChangeCount(ChangeCount + 1);
    } else {
      swal("Warning", "You must select cropped area first!", "warning");
    }
  };

  useEffect(() => {
   
    const array = Array.from(LayersData)

    for(let i = 0; i < array.length; i++)
    {
      if(value.key === array[i].key)
      {
        if(array[i].crop == "true")
        {
          cropImg(array[i].key)
        }
      }
      
    }
    
  }, [isCrop])
  



  const cancelCropImg = async (key) => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        array[i].crop = "false";
      }
    }
    setLayersData(array);
  };

  function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      try {
        // JPEG pictures stay JPEG (much smaller than PNG); others keep transparency as PNG.
        const src = String(image.currentSrc || image.src || "");
        const isJpeg = /^data:image\/jpe?g/i.test(src) || /\.jpe?g(\?|$)/i.test(src);
        resolve(isJpeg ? canvas.toDataURL("image/jpeg", 0.92) : canvas.toDataURL());
      } catch (e) {
        console.log("This picture cannot be cropped (no cross-origin permission).", e);
        reject(e);
      }
    });
  }

  const locked = (e) => {
    e.target.previousSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const LockShow = (e) => {
    e.target.nextSibling.style.display = "block";
    e.target.style.display = "none";
  };

  async function makeClientCrop(crop) {
    if (completedCrop && crop.width && crop.height) {
      try {
        const croppedImageUrl = await getCroppedImg(
          completedCrop,
          crop,
          "newFile.jpeg"
        );
        setCropedUrl(croppedImageUrl);
      } catch (e) {
        // keep the previous crop result
      }
    }
  }

  const enterKeyFrame = (
    width,
    height,
    y,
    x,
    rotation,
    widthOnTimeline,
    check
  ) => {
    if (check) {
      let AzAngle;
      if (rotation > 180) {
        AzAngle = rotation - 360;
      } else {
        AzAngle = rotation;
      }

      let Angle;
      if (value.rotateAngle > 180) {
        Angle = value.rotateAngle - 360;
      } else {
        Angle = value.rotateAngle;
      }
      var aikVariable = calculateSecondsByWidth(widthOnTimeline);
      const AnimationFrames = keyframes`0%{ left:${value.x}px; top:${value.y}px; width:${value.width}px; height:${value.height}px; transform:rotate(${Angle}deg); }  
                100%{ left:${x}px; top:${y}px; width:${width}px; height:${height}px; transform:rotate(${AzAngle}deg); }`;

      var styles = styled.div`
        position: absolute;
        animation: ${AnimationFrames} ${aikVariable}s linear;
        left: ${x}px;
        top: ${y}px;
        width: ${width}px;
        height: ${height}px;
        z-index: ${zInd};
        transform: rotate(${rotation}deg);
      `;
      setAnimationStyle(styles);
    } else {
      let AzAngle;
      if (rotation > 180) {
        AzAngle = rotation - 360;
      } else {
        AzAngle = rotation;
      }

      let Angle;
      if (value.originalRotateAngle > 180) {
        Angle = value.originalRotateAngle - 360;
      } else {
        Angle = value.originalRotateAngle;
      }
      var aikVariable = calculateSecondsByWidth(widthOnTimeline);
      const AnimationFrames = keyframes`0%{ left:${value.originalX}px; top:${value.originalY}px; width:${value.originalWidth}px; height:${value.originalHeight}px; transform:rotate(${Angle}deg); }  
                100%{ left:${x}px; top:${y}px; width:${width}px; height:${height}px; transform:rotate(${AzAngle}deg); }`;

      var styles = styled.div`
        position: absolute;
        animation: ${AnimationFrames} ${aikVariable}s linear;
        left: ${x}px;
        top: ${y}px;
        width: ${width}px;
        height: ${height}px;
        z-index: ${zInd};
        transform: rotate(${rotation}deg);
      `;
      setAnimationStyle(styles);
    }
  };

  const calculateSecondsByWidth = (width) => {
    let ms = parseFloat((width * onePxEquivalent).toFixed(3));
    return msToSeconds(ms);
  };

  const msToSeconds = (duration) => {
    var seconds = (duration / 1000).toFixed(2);
    return seconds;
  };

  const [crop, setCrop] = useState({
    unit: "px",
    width: 30,
    height: 30,
  });

  useEffect(() => {
    if (StoreData) {
      enterKeyFrame(
        StoreData.width,
        StoreData.height,
        StoreData.y,
        StoreData.x,
        StoreData.rotateAngle,
        StoreData.widthOnTimeline,
        true
      );
    }
  }, [StoreData]);

  // useEffect(() => {
  //   if (CanvasDisplay) {
  //     //console.log("ruk gea hai: " + CanvasDisplay);
  //   } else {
  //    // console.log("chal gea hai: " + CanvasDisplay);
  //   }
  // }, [CanvasDisplay]);

  useEffect(() => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      let aToZStart =
        array[i].startPositionOnTimeline + array[i].startTransitionWidth;
      if (
        array[i].AzData &&
        TickerPosition >= aToZStart &&
        TickerPosition <= array[i].AzData.widthOnTimeline + aToZStart
      ) {
        //let aToZEnd = array[i].AzData.widthOnTimeline + aToZStart;
        let remainingWidthOnTimeline =
          array[i].AzData.widthOnTimeline + aToZStart - TickerPosition;
        //let azData = clone(LayersData[i].AzData);
        //azData.widthOnTimeline = remainingWidthOnTimeline;
        enterKeyFrame(
          StoreData.width,
          StoreData.height,
          StoreData.y,
          StoreData.x,
          StoreData.rotateAngle,
          remainingWidthOnTimeline,
          true
        );
        //setStoreData(azData);
        //console.log("remainingWidthOnTimeline: " + remainingWidthOnTimeline);
      } else if (array[i].AzData && TickerPosition <= aToZStart) {
        enterKeyFrame(
          array[i].AzData.width,
          array[i].AzData.height,
          array[i].AzData.y,
          array[i].AzData.x,
          array[i].AzData.rotateAngle,
          array[i].AzData.widthOnTimeline,
          false
        );
      }
    }
  }, [TickerStart]);

  useEffect(() => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      let aToZStart =
        array[i].startPositionOnTimeline + array[i].startTransitionWidth;
      if (
        array[i].AzData &&
        Click_TickerPosition >= aToZStart &&
        Click_TickerPosition <= array[i].AzData.widthOnTimeline + aToZStart
      ) {
        let remainingWidthOnTimeline =
          array[i].AzData.widthOnTimeline + aToZStart - Click_TickerPosition;
        enterKeyFrame(
          StoreData.width,
          StoreData.height,
          StoreData.y,
          StoreData.x,
          StoreData.rotateAngle,
          remainingWidthOnTimeline,
          true
        );
        //console.log("remainingWidthOnTimeline: " + remainingWidthOnTimeline);
      } else if (array[i].AzData && Click_TickerPosition <= aToZStart) {
        enterKeyFrame(
          array[i].AzData.width,
          array[i].AzData.height,
          array[i].AzData.y,
          array[i].AzData.x,
          array[i].AzData.rotateAngle,
          array[i].AzData.widthOnTimeline,
          false
        );
      }
    }
  }, [Click_TickerPosition]);

  useEffect(() => {
    if (LayersData) {
      if (CanvasDisplay) {
        for (let i = 0; i < LayersData.length; i++) {
          if (LayersData[i].key == value.key && LayersData[i].AzData) {
            if (!StoreData) {
              setStoreData(clone(LayersData[i].AzData));
            } else {
              if (
                LayersData[i].AzData.x != StoreData.x ||
                LayersData[i].AzData.y != StoreData.y ||
                LayersData[i].AzData.width != StoreData.width ||
                LayersData[i].AzData.height != StoreData.height ||
                LayersData[i].AzData.widthOnTimeline !=
                  StoreData.widthOnTimeline ||
                LayersData[i].AzData.rotateAngle != StoreData.rotateAngle
              ) {
                setStoreData(clone(LayersData[i].AzData));
              }
            }
            break;
          }
        }
      }
    }
  }, [LayersData]);

  const Dragger = (e, data) => {
    if (data.node.nextSibling) {
      IsSetStateUpdate = true;
      data.node.nextSibling.style.left = data.x + "px";
      data.node.nextSibling.style.top = data.y + "px";
      //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    }
  };

  var IsSetStateUpdate = false;
  const DragEnd = async (e, data) => {
    //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].waitSS = true;
        newArray[i].toolbar = true;
        newArray[i].showDiv = true;
        IsSetStateUpdate = false;
        newArray[i].x = (data.x / EditorZoom) * 100;
        newArray[i].y = (data.y / EditorZoom) * 100;
      } else {
        newArray[i].toolbar = false;
        newArray[i].showDiv = false;
        if (newArray[i].type === "text") {
          newArray[i].edit = "false";
          if (newArray[i].FurtherSetting === true) {
            newArray[i].FurtherSetting = false;
          }
          if (newArray[i].Editable === true) {
            newArray[i].Editable = false;
          }
        }
      }
    }

    // const _slides = Array.from(slides);
    // const active_slides = _slides.find(x => x.IsActive === true);
    // active_slides.LayerData = newArray;

    // setTimeout(() => {

    //     if(!IsSetStateUpdate)
    //     {
    //         setslides(_slides)
    //     }

    // }, 7000);
    // if (!Call_ScreenShot) {
    //   setCall_ScreenShot(true);
    // }
    setLayersData(newArray);
  };

  const Click = (e, key) => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        array[i].Editable = true;
        array[i].toolbar = true;
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
      }
    }
    setLayersData(array);
  };

  const activeEdit = (params) => {
    if (!IsPressedShiftKey) {
      const newArray = Array.from(LayersData);
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].Editable = true;
          newArray[i].toolbar = true;
          newArray[i].showDiv = true;
        } else {
          newArray[i].Editable = false;
          newArray[i].toolbar = false;
          newArray[i].showDiv = false;
        }
      }
      setLayersData(newArray);
      //ShowPanelLeft
      seteditableObject({ showPanel: true, editableItem: value });
    }
  };

  const Activated = () => {
    if (MultiDrag.length > 1) {
      const arr = Array.from(MultiDrag);
      //setMultiDrag(arr);
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key == value.key) {
          if (value.InMultiDrag === false) {
            arr.push(array[i]);
            array[i].InMultiDrag = true;
          } else {
            const index = arr.indexOf(value);

            if (index > -1) {
              // only splice array when item is found
              arr.splice(index, 1); // 2nd parameter means remove one item only
            }
            value.InMultiDrag = false;
            var element = document.getElementsByClassName(
              "Inner-" + value.AnimationId
            );
            if (element.length > 0) {
              element.classList.remove("disableEvents");
            }
          }
        }
      }
      if (arr.length === 1) {
        setMultiDrag([]);
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === arr[0].key) {
            array[i].showDiv = true;
            array[i].Editable = true;
          }
        }
      } else {
        setMultiDrag(arr);
      }

      setLayersData(array);
    } else {
      let arr = [];
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key !== value.key) {
          if (array[i].Editable == true) {
            arr.push(array[i]);
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        } else {
          arr.push(array[i]);
        }
      }
      if (arr.length > 1) {
        setMultiDrag(arr);
        for (const itr of array) {
          for (const atr of arr) {
            if (atr.key == itr.key) {
              itr.InMultiDrag = true;
            }
            atr.toolbar = false;
          }
        }
        setLayersData(array);
      } else {
        for (var i = 0; i < array.length; i++) {
          if (array[i].key == value.key) {
            array[i].toolbar = true;
            array[i].Editable = true;
          } else {
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        }
        setLayersData(array);
        arr = [];
      }
    }
  };

  useEffect(() => {
    if (dragref.current) {
      dragref.current.style.transform = `translate(${
        (value.x * EditorZoom) / 100
      }px, ${(value.y * EditorZoom) / 100}px) rotate(${value.rotateAngle}deg)`;
    }
  }, [value.rotateAngle, dragref.current]);

  // var element = document.getElementsByClassName('jzmUzU ')[index]

  // useEffect(() => {
  //     if (element)
  //         element.addEventListener('click', function (e) {
  //             console.log('listen in tracker')
  //         })
  //     return () => {
  //         if (element)
  //             element.removeEventListener('click', console.log('Remove'))
  //     }
  // }, [element])
  const generateClassWithShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag disableEvents checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder disableEvents checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  const generateClassWithoutShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  return (
    <>
      {value.crop === "false" && value.opc === 1 && (
        <>
          {!value.startAtoZ && (
            <>
              {!value.Editable && CanvasDisplay && value.lock === false && (
                <Draggable
                  defaultClassName={
                    IsPressedShiftKey
                      ? generateClassWithoutShift()
                      : generateClassWithShift()
                  }
                  onMouseDown={(e) => {
                    if (e.shiftKey) {
                      Activated();
                      return false;
                    }
                  }}
                  onStart={(e) => {
                    if (e.shiftKey) {
                      return false;
                    } else {
                      setMultiDrag([]);
                      setDragging(true);
                      seteditableObject({
                        showPanel: true,
                        editableItem: value,
                      });
                    }
                  }}
                  onDrag={(event, data) => Dragger(event, data)}
                  onStop={(event, data) => {
                    DragEnd(event, data);
                    setDragging(false);
                  }}
                  cancel={".resizable-handler , .square , .rotate"}
                  position={{
                    x: (value.x * EditorZoom) / 100,
                    y: (value.y * EditorZoom) / 100,
                  }}

                  //defaultPosition={{ x: (value.x * EditorZoom) / 100, y: (value.y * EditorZoom) / 100 }}
                >
                  <div
                    id={`Inner-${value.AnimationId}`}
                    ref={dragref}
                    onClick={activeEdit}
                    style={{
                      // display: (!CanvasDisplay ? 'none' :
                      //     TickerStart ? (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ?
                      //         'inline-block' : 'none' : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' : 'none'),

                      display: !CanvasDisplay
                        ? value.player
                          ? "inline-block"
                          : "none"
                        : value.startPositionOnTimeline <= TickerPosition &&
                          value.startPositionOnTimeline +
                            value.widthOnTimeline >=
                            TickerPosition
                        ? "inline-block"
                        : "none",
                      width: (value.width * EditorZoom) / 100,
                      height: (value.height * EditorZoom) / 100,
                    }}
                  ></div>
                </Draggable>
              )}

              <div
                id={`Outer-${value.AnimationId}`}
                ref={!value.Editable ? imageRef : resizeRef}
                // className={"changer " + (!CanvasDisplay ? value.InClass + value.OutClass : '')}
                className={
                  "changer EditStart " +
                  (value.Editable ? " RectBorder " : "") +
                  (!CanvasDisplay ? value.InClass + value.OutClass : "")
                }
                style={{
                  VendorAnimationDuration: ".5s",
                  display: !CanvasDisplay
                    ? value.player
                      ? "inline-block"
                      : "none"
                    : value.startPositionOnTimeline <= TickerPosition &&
                      value.startPositionOnTimeline + value.widthOnTimeline >=
                        TickerPosition
                    ? "inline-block"
                    : "none",
                  width: (value.width * EditorZoom) / 100,
                  height: (value.height * EditorZoom) / 100,
                  zIndex: zInd,
                  transform: CanvasDisplay
                    ? `rotate(${value.rotateAngle}deg)`
                    : "",
                  top: (value.y * EditorZoom) / 100,
                  left: (value.x * EditorZoom) / 100,
                  position: "absolute",
                }}
                onClick={() => {
                  const newArray = Array.from(LayersData);
                  for (var i = 0; i < newArray.length; i++) {
                    if (newArray[i].key === value.key) {
                      newArray[i].Editable = true;
                      if (!newArray[i].lock) {
                        newArray[i].toolbar = true;
                      }
                    } else {
                      newArray[i].Editable = false;
                      newArray[i].toolbar = false;
                    }
                  }
                  setLayersData(newArray);
                }}
              >
                <div
                  className={"DivTag"}
                  draggable={false}
                  style={{
                    zIndex: value.Editable != false ? "-1" : "",
                    transform: !CanvasDisplay
                      ? `rotate(${value.rotateAngle}deg)`
                      : "",
                    display: value.InMultiDrag ? "none" : "block",
                  }}
                >
                  <img
                    id={"image-" + value.AnimationId}
                    className="ImgTag"
                    style={{ transform: value.flip, opacity: value.opacity }}
                    draggable={false}
                    src={value.ImageSrc}
                  />
                </div>
              </div>

              {value.showDiv === true && (
                <div
                  id={`showDiv-${value.AnimationId}`}
                  ref={resizeRef2}
                  style={{
                    VendorAnimationDuration: ".5s",
                    cursor: value.lock == true ? "default" : "grab",
                    transform: CanvasDisplay
                      ? `rotate(${value.rotateAngle}deg)`
                      : "",
                    display: !CanvasDisplay
                      ? value.player && !value.startAtoZ
                        ? "inline-block"
                        : "none"
                      : value.startPositionOnTimeline <= TickerPosition &&
                        value.startPositionOnTimeline + value.widthOnTimeline >=
                          TickerPosition
                      ? "inline-block"
                      : "none",
                    height: (value.height * EditorZoom) / 100,
                    width: (value.width * EditorZoom) / 100,
                    zIndex: !value.lock ? 1000 : 1100 + 50,
                    border:
                      value.lock == true
                        ? "1px dashed black"
                        : value.Editable
                        ? "2px solid #e87ed4"
                        : "",
                    left: Math.round((value.x * EditorZoom) / 100),
                    top: Math.round((value.y * EditorZoom) / 100),
                    position: "absolute",
                  }}
                ></div>
              )}
            </>
          )}

          {value.startAtoZ && (
            <AnimationStyle>
              <div
                className={(value.Editable ? "RectBorder " : "") + "DivTag"}
                draggable={false}
                style={{
                  zIndex: value.Editable != false ? "-1" : "",
                }}
              >
                {" "}
                <img
                  className="ImgTag"
                  style={{
                    transform: value.flip,
                    opacity: value.opacity,
                  }}
                  draggable={false}
                  src={value.ImageSrc}
                />
              </div>
            </AnimationStyle>
          )}
        </>
      )}

      {value.crop === "true" && value.lock === false && value.opc === 1 && (
        <>
          <div
            key={index}
            ref={value.Editable === true ? resizeRef : null}
            className={
              "changer " +
              (!CanvasDisplay ? value.InClass + value.OutClass : "")
            }
            style={{
              VendorAnimationDuration: ".5s",
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline +
                    value.widthOnTimeline -
                    value.startTransitionWidth >=
                    TickerPosition
                ? "inline-block"
                : "none",
              width: (value.width * EditorZoom) / 100,
              height: (value.height * EditorZoom) / 100,
              zIndex: 1200,
              position: "absolute",
              left: Math.round((value.x * EditorZoom) / 100),
              top: Math.round((value.y * EditorZoom) / 100),
            }}
            onClick={(event) => Click(event, value.key)}
          >
            <div style={{ position: "relative" }}>
              <ReactCrop
                crop={crop}
                onChange={(c) => onCropChange(c)}
                onComplete={(c) => onCropComplete(c)}
              >
                {/* Pictures are links now (Utils/layerImages.js). Cropping reads the pixels, so a
                    linked picture is loaded with cross-origin permission (separate cache entry). */}
                <img
                  src={
                    String(value.ImageSrc).startsWith("data:")
                      ? value.ImageSrc
                      : value.ImageSrc + (String(value.ImageSrc).includes("?") ? "&" : "?") + "forCrop=1"
                  }
                  crossOrigin={String(value.ImageSrc).startsWith("data:") ? undefined : "anonymous"}
                  style={{ width: value.width, height: value.height }}
                  onLoad={(e) => onImageLoaded(e)}
                />
              </ReactCrop>
            </div>

            <button
              onClick={() => cropImg(value.key)}
              className="btn btn-primary"
              style={{
                height: "28px",
                padding: "1px 9px",
                "margin-right": "3px",
              }}
            >
              <span class="material-icons">done</span>
            </button>
            <button
              onClick={() => cancelCropImg(value.key)}
              className="btn btn-primary"
              style={{ height: "28px", padding: "1px 9px" }}
            >
              <span class="material-icons">close</span>
            </button>
          </div>
        </>
      )}

      {/* {value.lock === true && value.opc === 1 && (
        <LockBar
          value={value}
          EditorZoom={EditorZoom}
          LayersData={LayersData}
          setLayersData={setLayersData}
        />
      )} */}

      {value.crop === "false" && value.lock === true && value.opc === 1 && (<>
            <div className='RectBorder' key={index} style={{
                position: "absolute", transform: `rotate(${value.rotateAngle}deg)`, height: (value.height * EditorZoom) / 100,
                left: Math.round((value.x * EditorZoom) / 100), top: Math.round((value.y * EditorZoom) / 100),
                width: (value.width * EditorZoom) / 100, zIndex:  1500,
                display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                ? "inline-block"
                : "none",
            }}>
                <img key={index} className="ImgTag" style={{ transform: value.flip ,zIndex: zInd }} tabIndex="0" draggable="false" src={value.ImageSrc}></img>
                <div data_set="lock_object" className="LockTop">
                    <div key={index} className="LockInnerBorder">
                        <span className="material-icons material-icons-outlined Lockback" tabIndex="0" onMouseOver={LockShow}>lock</span>
                        <span className="material-icons material-icons-outlined unlock " tabIndex="0" onMouseOut={locked} onClick={() => Unlock(value.key)}>lock_open</span>
                    </div>
                </div>
            </div>
        </>)}
    </>
  );
};
export default TrackerImages;
